import React from 'react'
import { ISellCard } from '@et/types/Courses'
import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import ImgSmall from '@components/imageModules/v2/imgSmall'
import { IGatsbyChildImageSharp } from '@et/types/Gatsby'
import {
  flashContentVariants,
  FlashCardImg,
  flashOverlayVariants,
  FlashOverlay,
  FlashCardBg
} from '@styles/modules/flashCardStyles'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { device } from '@styles/global/breakpoints'
interface Props {
  title: string,
  classDescriptor: string,
  image: {
    gatsbyImageData?: IGatsbyImageData
    childImageSharp?: IGatsbyChildImageSharp
  }
  sellCard: ISellCard
  shadows: {
    init: string
    hover: string
  }
  customCardBg?: string | undefined,
}
const FlashCardStatic = (props: Props) => {
  const { sellCard, shadows, image, title, classDescriptor, customCardBg } = props

  return (
    <FlashCardStaticLink>
      <FlashCardStaticContent
        custom={{
          h2Color: sellCard.h2Color,
          h2HoverColor: sellCard.hoverColor.h2,
          shadows,
        }}
        initial={'init'}
        variants={flashContentVariants}
      >
        <FlashCardImg>
          <FlashOverlay
            variants={flashOverlayVariants}
            color={sellCard.hoverColor.overlay}
          />
          {image.childImageSharp &&
            <ImgSmall critical={IMAGELOADINGENUMS.LAZY} gatsbyImage={image.childImageSharp} alt={'Buy Now'}/>
          }
          {image.gatsbyImageData &&
            <GatsbyImage alt={`Buy Now! ${title}`}
                         loading={IMAGELOADINGENUMS.LAZY}
                         image={image.gatsbyImageData}/>
          }
        </FlashCardImg>
        <Info>
          <h2>{title}</h2>
        </Info>
        {/*<FlashTagline*/}
        {/*  variants={flashTaglineVariants}*/}
        {/*  custom={{cardDescription: sellCard.hoverColor.cardDescription}}>{classDescriptor}*/}
        {/*</FlashTagline>*/}
      </FlashCardStaticContent>
      <FlashCardBg />
    </FlashCardStaticLink>
  )
}

export const FlashCardStaticLink = styled(motion.div)`
  position: relative;
  width: 100%;
  max-width: 315px;
  height: 500px;
  margin: 0 auto;
  cursor: pointer;
  display: block;

  @media ${device.tablet}{
    margin: 0 0 0 auto;  
  }
  @media ${device.laptop}{
    &:hover{
      cursor: pointer;
      .numberDisplay,
      .dollar,
      .num{
        color: #fff;
      }
    }
  }
  @media ${device.laptopL} {
    margin: 0 0 0 70px;
    max-width: 360px;
  } 
`
const Info = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 2;
  margin-bottom: 30px;
`
export const FlashCardStaticContent = styled(motion.div)`
  border-radius: 15px;
  transform-origin: bottom left;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
  justify-content: flex-end;
  
  h2, p{
    text-align: center;
  }
  h2{
    font-size: 24px;
    line-height: 28px;
  }
`
export default FlashCardStatic
